<template>
  <ExternalQueryList
      endpoint="/api/v2/reminders"
      :headlines="headlines"
      :filters="filters"
      :can-update="() => true"
      @show="reminder => $router.push(getUrl(reminder))"
  >
    <template v-slot:default="{ row: reminder }">
      <td class="table__ellipsis">
        <router-link :to="getSubjectUrl(reminder)">
          {{ reminder.attributes.subject_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        <span v-if="reminder.attributes.priority === 'high'" class="label label-danger">
          High
        </span>

        <span v-if="reminder.attributes.priority === 'medium'" class="label label-warning">
          Medium
        </span>

        <span v-if="reminder.attributes.priority === 'low'" class="label label-success">
          Low
        </span>
      </td>

      <td class="table__ellipsis">
        <Avatar :color="reminder.attributes.user_color">
          {{ reminder.attributes.user_initials }}
        </Avatar>
      </td>

      <td class="table__ellipsis">
        {{ reminder.attributes.remind_at | datetime }}
      </td>

      <td class="table__ellipsis">
        {{ reminder.attributes.portals.map(portal => portal.name).join(' &middot; ') }}
      </td>

      <td class="table__ellipsis">
        <span v-if="reminder.attributes.resolved_at" class="label label-success">
          Resolved
        </span>

        <span v-else class="label label-warning">
          Unresolved
        </span>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import moment from 'moment'
import Avatar from '../../../Avatar'
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import StatusLabel from '../../../StatusLabel'

export default {
  components: { Avatar, ExternalQueryList, StatusLabel},

  props: {
    users: {
      required: true
    },

    portals: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 6, text: 'Subject'},
        {width: 2, text: 'Priority', sort_column: 'priority'},
        {width: 2, text: 'User'},
        {width: 4, text: 'Due Date', sort_column: 'remind_at'},
        {width: 6, text: 'Portals'},
        {width: 2, text: 'Status'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 4,
            widget: 'select',
            name: 'user_id',
            options: this.users.map(user => ({value: user.id, label: user.attributes.full_name})),
            nullable: true,
            placeholder: '(all users)'
          },
          {
            width: 4,
            widget: 'select',
            name: 'portal_id',
            options: this.portals.map(portal => ({value: portal.id, label: portal.attributes.name})),
            nullable: true,
            placeholder: '(all portals)'
          },
          {
            width: 3,
            widget: 'select',
            name: 'priority',
            options: [
              {value: 'low', label: 'Low'},
              {value: 'medium', label: 'Medium'},
              {value: 'high', label: 'High'},
            ],
            nullable: true,
            placeholder: '(all priorities)'
          },
          {
            width: 3,
            widget: 'select',
            name: 'remind_to',
            options: [
              {value: moment().format('YYYY-MM-DD'), label: 'Today'},
              {value: moment().add(1, 'days').format('YYYY-MM-DD'), label: '+1 day'},
              {value: moment().add(2, 'days').format('YYYY-MM-DD'), label: '+2 days'},
              {value: moment().add(3, 'days').format('YYYY-MM-DD'), label: '+3 days'},
              {value: moment().add(7, 'days').format('YYYY-MM-DD'), label: '+7 days'},
              {value: moment().add(14, 'days').format('YYYY-MM-DD'), label: '+14 days'},
              {value: moment().add(30, 'days').format('YYYY-MM-DD'), label: '+30 days'},
            ],
            nullable: true,
            placeholder: '(all due dates)'
          },
          {
            width: 4,
            widget: 'select',
            name: 'status',
            options: [{value: 'resolved', label: 'Resolved'}, {value: 'unresolved', label: 'Unresolved'}],
            nullable: true,
            placeholder: '(all statuses)'
          },
          {
            width: 3,
            widget: 'button',
            class: 'btn-white',
            text: '<i class="fa fa-times"></i> Clear',
            event: 'clear'
          },
          {
            width: 3,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(reminder) {
      return this.getSubjectUrl(reminder) + '/timeline'
    },

    getSubjectUrl(reminder) {
      return '/' + reminder.attributes.subject_type + '/' + reminder.attributes.subject_id
    }
  }
}
</script>
